<footer class="footer" style="position: static !important">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="text-sm-end d-none d-sm-block">
          <i class="mdi mdi-heart text-danger"></i> by
          <a href="" target="_blank" class="text-reset">IGB Network</a>
        </div>
      </div>
    </div>
  </div>
</footer>
